import { SettingsPage } from '@/components/words/settings-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/words/settings')({
  component: SettingsPage,
});
